export default {
  apiUrl: () => {
    if (process.env.NODE_ENV === 'development')
      return 'http://localhost:5000';
    else
      return 'https://api.artbuffer.com';
  },
}
